import { CurrencyPipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    ValidationErrors,
    Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { CsvExportService } from 'src/app/services/csv-export.service';
import { ExportRangeDialogConfigData } from '../../../batch/types/batch';

interface ExportFormType {
  start_date: FormControl;
  end_date: FormControl;
}

@Component({
  selector: 'export-date-range',
  templateUrl: 'component.html',
  styleUrls: ['component.scss'],
  standalone: false,
})
export class ExportDateRange implements OnInit {
  public form: FormGroup<ExportFormType>;
  public loading = false;

  constructor(
    protected dialogRef: MatDialogRef<ExportDateRange>,
    @Inject(MAT_DIALOG_DATA)
    private readonly data: ExportRangeDialogConfigData,
    private cp: CurrencyPipe,
  ) {}

  ngOnInit(): void {
    const fields = {
      start_date: [null, [Validators.required]],
      end_date: [null, [Validators.required]],
    };

    this.form = new FormBuilder().group(fields, {
      validators: [this.validateForm],
    });
  }

  validateForm(group: FormGroup<ExportFormType>): ValidationErrors {
    let diff = moment(group.controls.end_date.value).diff(
      moment(group.controls.start_date.value),
      'days',
    );
    let error =
      diff < 1
        ? { dateRange: 'End date must be after start date' }
        : diff >= 1000
          ? { dateRange: 'Date range must be less than 1000 days' }
          : null;
    group.controls.end_date.setErrors(
      group.controls.end_date.errors
        ? { ...group.controls.end_date.errors, ...error }
        : error,
    );
    return error;
  }

  onSubmit() {
    const { batchApi } = this.data;

    this.form.disable();
    this.loading = true;

    batchApi
      .getBatchExport('finance-admin', {
        startDate: moment(this.form.controls.start_date.value).unix(),
        endDate: moment(this.form.controls.end_date.value)
          .add(1, 'days')
          .unix(),
      })
      .then((response: any) => {
        if (response.data?.length > 0) {
          this.downloadCSV(response.data);
        }
        return this.dialogRef.close();
      })
      .catch(() => this.form.enable())
      .finally(() => (this.loading = false));
  }

  public downloadCSV(data) {
    const headers = [
      'Payment Date',
      'First Name',
      'Surname',
      'Account ID',
      'Title',
      'Total',
      'Event Date',
    ];
    const fileName = 'batch-export';

    const formattedRows = data.map((order) => {
      try {
        const totalFloat = (Number(order.total) / 100).toFixed(2);
        const price = this.cp.transform(
          totalFloat,
          'GBP',
          'symbol-narrow',
          '1.2-2',
        );

        return [
          order.paymentDate,
          order.firstName,
          order.surname,
          order.accountId,
          order.title,
          price,
          order.displayDate,
        ];
      } catch (e) {
        console.log(e);
      }
      return null;
    });

    CsvExportService.export(formattedRows, fileName, {
      showLabels: true,
      headers,
    });
  }
}
